module.exports = __webpack_public_path__ + "static/media/clearbit-mobiles-2-tiny.4c553314.jpg";